import { EventEmitter as AEventEmitter } from 'ahooks/lib/useEventEmitter';
import { useContext } from 'react';
import { useStore as useZustandStore } from 'zustand';
import { useShallow } from 'zustand/shallow';
import { createStore } from 'zustand/vanilla';
import { WorkflowContext } from './context';
import { EventEmitter as EventEmitterFromContext } from '@/pages/CustomCenter/context/eventEmmitrContent';

export type EventEmitter = AEventEmitter<{
  type: 'NODE_CLICK' | 'ADD_NODE' | 'SWITCH_TAB';
  payload?: {
    node_id?: string;
    resolve?: (value: any) => void;
    reject?: (reason?: any) => void;
  };
}>;

interface Shape {
  mode: 'edit' | 'create' | 'preview' | 'published';
  appId: string;
  template_code: string;
  panelWidth: number;
  draftUpdatedAt: number;
  publishedAt: number;
  notInitialWorkflow: boolean;
  /** 是否正在保存  */
  isSyncingWorkflowDraft: boolean;
  syncWorkflowDraftHash: string;
  readonly: boolean;

  eventEmitter?: EventEmitter;
  eventFromContext?: EventEmitterFromContext;
}

export const createWorkflowStore = ({
  eventEmitter,
  eventFromContext,
}: {
  eventEmitter: EventEmitter;
  eventFromContext?: EventEmitterFromContext;
}) => {
  return createStore<Shape>(() => ({
    mode: 'create',
    appId: '',
    readonly: false,
    template_code: '',
    panelWidth: 420,
    draftUpdatedAt: 0,
    notInitialWorkflow: false,
    publishedAt: 0,
    syncWorkflowDraftHash: '',
    isSyncingWorkflowDraft: false,
    eventEmitter,
    eventFromContext,
  }));
};

export function useStore<T>(selector: (state: Shape) => T): T {
  const store = useContext(WorkflowContext);
  if (!store) throw new Error('Missing WorkflowContext.Provider in the tree');

  return useZustandStore(store, useShallow(selector));
}

export const useWorkflowStore = () => {
  return useContext(WorkflowContext)!;
};
